import {gsap} from "gsap";
import {MutableRefObject, useEffect} from "react";

const useBackdrop = (container: MutableRefObject<HTMLDivElement>, fullWidth: boolean, duration: number, ease: string | gsap.EaseFunction) => {
    useEffect(() => {
        const element = container.current;
        if (!element) {
            return;
        }

        const baseTweenVars = {
            duration,
            ease,
        };

        const blurStart = 'blur(0px)';
        const blurEnd = 'blur(4px)';
        const backgroundColorStart = 'rgba(0, 0, 0, 0)';
        const backgroundColorEnd = 'rgba(0, 0, 0, .7)';

        if (fullWidth) {
            element.style.display = 'initial';
            const tween = gsap.fromTo(
                element,
                {
                    backgroundColor: backgroundColorStart,
                    backdropFilter: blurStart,
                },
                {
                    ...baseTweenVars,
                    backgroundColor: backgroundColorEnd,
                    backdropFilter: blurEnd,
                }
            );
            return () => {
                tween.kill();
            };
        } else {
            const tween = gsap.fromTo(
                element,
                {
                    backgroundColor: backgroundColorEnd,
                    backdropFilter: blurEnd,
                },
                {
                    ...baseTweenVars,
                    backgroundColor: backgroundColorStart,
                    backdropFilter: blurStart,
                    onComplete: () => {
                        element.style.display = 'none';
                    },
                }
            );
            return () => {
                tween.kill();
            };
        }

    }, [container, fullWidth, duration, ease]);
};

export default useBackdrop;
